import React, { useEffect } from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiGet } from "../lib/api";

const STATUS = {
  Active: { bg: "#DCFCE7", color: "#166534" },
  Due: { bg: "#FEF3C7", color: "#854D0E" },
  Overdue: { bg: "#FEE2E2", color: "#7F1D1D" },
  "Out of Service": { bg: "#F3F4F6", color: "#374151" },
};

function normalizeStatus(status) {
  const value = String(status || "Active").toLowerCase();
  if (value === "out_of_service" || value === "out of service") return "Out of Service";
  if (value === "overdue") return "Overdue";
  if (value === "due") return "Due";
  return "Active";
}

function mapEquipmentTool(row) {
  return {
    id: row.equipment_code || `EQ-${row.id}`,
    equipmentName: row.name || "",
    category: row.category || "",
    site: row.site_name || "",
    assignedTo: row.assigned_to || "",
    frequency: row.inspection_frequency || "",
    lastInspectionDate: row.last_inspection_date || "",
    nextDueDate: row.next_due_date || "",
    status: normalizeStatus(row.status),
    remarks: row.remarks || "",
    backendId: row.id,
    siteId: row.site_id,
  };
}

export default function EquipmentTools() {
  const { data, setData, siteNames } = useHSE();
  const categories = data.settings.equipmentCategories || [];

  useEffect(() => {
    let cancelled = false;

    async function loadEquipmentTools() {
      try {
        const rows = await apiGet("/api/equipment-tools");
        if (cancelled || !Array.isArray(rows)) return;

        const mapped = rows.map(mapEquipmentTool);
        if (!mapped.length) return;

        setData((prev) => ({
          ...prev,
          equipmentTools: mapped,
        }));
      } catch (error) {
        console.warn("Equipment API unavailable, using local fallback data.", error);
      }
    }

    loadEquipmentTools();

    return () => {
      cancelled = true;
    };
  }, [setData]);

  return (
    <RegisterPage
      title="Equipment & Power Tools"
      subtitle="Construction equipment and portable power tool inspection register"
      storeKey="equipmentTools"
      idPrefix="EQ"
      columns={[
        { key: "id", label: "Equipment ID" },
        { key: "equipmentName", label: "Equipment / Tool Name" },
        { key: "category", label: "Category" },
        { key: "site", label: "Site" },
        { key: "assignedTo", label: "Assigned To / Responsible" },
        { key: "frequency", label: "Inspection Frequency" },
        { key: "lastInspectionDate", label: "Last Inspection" },
        { key: "nextDueDate", label: "Next Due" },
        { key: "status", label: "Status" },
        { key: "remarks", label: "Remarks" },
      ]}
      badgeMap={{ status: STATUS }}
      formFields={[
        { key: "id", label: "Equipment ID" },
        { key: "equipmentName", label: "Equipment / Tool Name" },
        { key: "category", label: "Category", type: "select", options: categories },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "assignedTo", label: "Assigned To / Responsible Person" },
        { key: "frequency", label: "Inspection Frequency", type: "select", options: ["Daily", "Weekly", "Monthly"] },
        { key: "lastInspectionDate", label: "Last Inspection Date", type: "date" },
        { key: "nextDueDate", label: "Next Due Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Active", "Due", "Overdue", "Out of Service"] },
        { key: "remarks", label: "Remarks", type: "textarea", full: true },
      ]}
    />
  );
}
